import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUserDetail } from "../../../api/user";
import { Tabs, DetailHeaderCard, Button } from "../../../components";
import { RiEdit2Fill } from "react-icons/ri";
import dayjs from "dayjs";
import { DATETIME_FORMAT } from "../../../shared/constants";
import { Pages } from "../../../shared/enums";
import UserWallet from "./tabs/wallet";
import UserOrder from "./tabs/order";

const UserDetail = ({ }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { id } = useParams()
    const [data, setData] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const response = await getUserDetail(id)
        setData(response)
    }

    const tabList = [
        { key: "order", label: t("ORDER"), content: <UserOrder /> },
        { key: "wallet", label: t("WALLET"), content: <UserWallet /> },
    ];

    if (!data) return <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100vh - 100px)" }}><Spinner /></div>

    const details = [
        { label: t("PHONE_NUMBER"), value: `${data.countryCode}${data.phoneNumber}` },
        { label: t("EMAIL"), value: data.email },
        { label: t("GENDER"), value: data.gender },
        { label: t("REFERENCE_NUMBER"), value: data.referenceNumber },
        {
            label: t("SUSPENDED"),
            value: <span className={data.suspended ? "text-danger" : "text-success"}>{data.suspended ? "Yes" : "No"}</span>
        },
        { label: t("JOINED_AT"), value: dayjs(data.createdAt).format(DATETIME_FORMAT) },
    ];

    return <div className="p-4">
        <DetailHeaderCard
            title={data.fullName}
            rightComponent={<Button
                size="sm"
                variant="outline-primary"
                icon={<RiEdit2Fill />}
                onClick={() => navigate(Pages.UserForm.replace(":id", id))}
            />}
            details={details}
        />
        <Tabs tabList={tabList} />
    </div>
}

export default UserDetail;